<template>
  <div class="register">
    <app-header />
    <div class="register-content">
      <Card header="Create your FREE account" type="secondary">
        <form class="form" @submit.prevent="onRegister">
          <div class="form-content">
            <!-- First Name -->
            <ag-form-group
              label="First Name"
              id="firstName"
              :validator="$v.register.firstName"
            >
              <ag-input
                id="firstName"
                :value="register.firstName"
                @change="setProp($event, 'firstName')"
              />
            </ag-form-group>
            <!-- Last Name -->
            <ag-form-group
              label="Last Name"
              id="lastName"
              :validator="$v.register.lastName"
            >
              <ag-input
                id="lastName"
                :value="register.lastName"
                @change="setProp($event, 'lastName')"
              />
            </ag-form-group>

            <!-- Email -->
            <ag-form-group
              label="Email"
              id="email"
              :validator="$v.register.email"
            >
              <ag-input
                id="email"
                :value="register.email"
                @change="setProp($event, 'email')"
              />
            </ag-form-group>

            <!-- Password -->
            <ag-form-group
              label="Password"
              id="password"
              :validator="$v.register.password"
            >
              <div>
                <ag-input
                  id="password"
                  type="password"
                  :value="register.password"
                  @change="setProp($event, 'password')"
                />
                <password-strength-meter
                  v-model="register.password"
                  :strength-meter-only="true"
                  @score="onPasswordScore"
                  @feedback="onPasswordFeedback"
                />
                <div
                  class="password-feedback"
                  v-if="register.password && passwordFeedback"
                >
                  <div class="warning" v-if="passwordFeedback.warning">
                    {{ passwordFeedback.warning }}
                  </div>
                  <div class="suggestions" v-if="passwordFeedback.suggestions">
                    <div
                      v-for="(suggestion, index) in passwordFeedback.suggestions"
                      :key="index"
                      class="suggestion"
                    >
                      {{ suggestion }}
                    </div>
                  </div>
                </div>
              </div>
            </ag-form-group>

            <!-- Repeat Password -->
            <ag-form-group
              label="Repeat Password"
              id="repeat-password"
              :validator="$v.register.repeatPassword"
              :messages="localMessages"
            >
              <ag-input
                id="repeat-password"
                type="password"
                :value="register.repeatPassword"
                @change="setProp($event, 'repeatPassword')"
              />
            </ag-form-group>
          </div>

          <div v-if="error">
            {{ error }}
          </div>

          <ag-button type="submit" :disabled="$v.$invalid">Submit</ag-button>
        </form>
      </Card>
    </div>
  </div>
</template>

<script>
  import { required, email, sameAs } from "vuelidate/lib/validators";
  import UserService from "../services/user-service";
  import PasswordStrengthMeter from "vue-password-strength-meter";
  import Card from "../components/Card";
  import AppHeader from "@/components/Header";

  export default {
    name: "Register",
    data: () => ({
      register: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        repeatPassword: ""
      },
      passwordScore: null, // Integer from 0-4
      passwordFeedback: null, // Object containing 'warning' (String) and 'feedback' (Array)
      error: null,
      localMessages: {
        sameAsPassword: "Passwords must match"
      }
    }),
    methods: {
      setProp(value, property) {
        this.register[property] = value;
        const validationProp = this.$v["register"][property];
        if (validationProp) {
          validationProp.$touch();
        }
      },
      async onRegister() {
        this.error = "";

        const { firstName, lastName, email, password } = this.register;

        try {
          await UserService.register(firstName, lastName, email, password);

          this.$router.push({ name: "Login" });
        } catch (error) {
          // TODO, handle Email already in use...
          console.error("Error registering: ", error);
          this.error = "Oops, something went wrong, please try again.";
        }
      },
      onPasswordScore(score) {
        this.passwordScore = score;
      },
      onPasswordFeedback(feedback) {
        this.passwordFeedback = feedback;
      }
    },
    validations: {
      register: {
        firstName: {
          required
        },
        lastName: {
          required
        },
        email: {
          required,
          email
        },
        password: {
          required
        },
        repeatPassword: {
          required,
          sameAsPassword: sameAs("password")
        }
      }
    },
    components: {
      AppHeader,
      Card,
      PasswordStrengthMeter
    }
  };
</script>

<style lang="scss">
  .register {
    display: flex;
    flex-direction: column;
    height: 100%;

    .register-content {
      padding: $gutter;
    }

    .header {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .form {
      flex-grow: 1;
      display: flex;
      flex-direction: column;

      .form-content {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .form-group {
          width: 100%;
          max-width: 500px;
        }
      }

      .Password .Password__strength-meter {
        margin-bottom: 6px;
      }

      .password-feedback {
        .warning {
          font-weight: $font-semibold;
          margin: 10px 0 6px 0;
          text-align: center;
        }

        .suggestions {
          text-align: center;
          font-style: oblique;

          .suggestion {
            margin-top: 4px;
          }
        }
      }
    }
  }
</style>
